import React from "react";
import { FONT } from "../../kota/ui";

// Kernet bus PO Sumber Jawsel: nongol di pojok kiri bawah sambil menghitung ongkos & nyeletuk sarkas ke sopir.
// 3 ekspresi (ilustrasi AI, /kerja/kernet_{pesan|kecewa|puas}.webp) ditumpuk & dimuat sejak awal → ganti ekspresi instan.
const GAMBAR = { pesan: "/kerja/kernet_pesan.webp", kecewa: "/kerja/kernet_kecewa.webp", puas: "/kerja/kernet_puas.webp" };
if (typeof Image !== "undefined") Object.values(GAMBAR).forEach(src => { const im = new Image(); im.src = src; });

export function Kernet({ nama, nada = "pesan", ucapan }) {
  const warna = nada === "kecewa" ? "#dc2626" : nada === "puas" ? "#2e9e5b" : "rgba(0,0,0,.14)";
  const aktif = GAMBAR[nada] ? nada : "pesan";
  return (
    <div data-testid="kernet" data-nada={nada} style={{ position: "absolute", inset: 0, fontFamily: FONT, pointerEvents: "none" }}>
      {Object.entries(GAMBAR).map(([k, src]) => (
        <img key={k} src={src} alt="" draggable={false} data-testid={`kernet-gambar-${k}`}
          style={{ position: "absolute", left: 4, bottom: 0, height: "100%", width: "auto", opacity: aktif === k ? 1 : 0, transition: "opacity .12s", filter: "drop-shadow(0 6px 6px rgba(20,20,20,.3))" }} />
      ))}
      {ucapan && (
        <div data-testid="ucapan" key={ucapan} style={{ position: "absolute", left: "26%", right: 12, bottom: 8, padding: "6px 10px 7px", borderRadius: 14, borderBottomLeftRadius: 5, background: "#fff", border: `2px solid ${warna}`, boxShadow: "0 8px 24px rgba(20,20,20,.2)", animation: "jw-datang .25s ease-out" }}>
          <span style={{ display: "block", fontSize: 10, fontWeight: 700, color: "#6b6b6b", marginBottom: 1 }}>{nama} · Kernet</span>
          <span style={{ fontSize: 12.5, fontWeight: 700, lineHeight: 1.3, color: "#141414" }}>{ucapan}</span>
          <span style={{ position: "absolute", left: -11, bottom: 14, width: 0, height: 0, borderTop: "7px solid transparent", borderBottom: "7px solid transparent", borderRight: "11px solid #fff", filter: `drop-shadow(-2px 0 0 ${warna})` }} />
        </div>
      )}
      <style>{`@keyframes jw-datang{0%{opacity:0;transform:translateY(8px)}100%{opacity:1;transform:translateY(0)}}`}</style>
    </div>
  );
}
